module.exports = __webpack_public_path__ + "2e01e6ddaa4f7c0a95e0087f99ef3242.MP3";